import React, { useState } from "react";
import TableActionsMenu from "../../../Components/TableActionsMenu/TableActionsMenu";
import { Avatar, AvatarFallback, AvatarImage } from "../../../shadcn/components/ui/avatar";
import { TableCell, TableRow } from "../../../shadcn/components/ui/table";
import { useTranslation } from "../../../context/Internationalization";
import { sports } from "../../../utility/Enum";

const ClubsTableRow = ({ club, menuActions, lastElementRef }) => {
  const { t } = useTranslation();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuActionsOpen = Boolean(menuAnchorEl);

  const handleClickActionMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleCloseActionMenu = () => {
    setMenuAnchorEl(null);
  };

  const getSportTranslation = (sport) => {
    const sportTranslation = sports(t).find(
      (item) => item.value === sport?.toLowerCase()
    );
    return sportTranslation?.text;
  };

  return (
    <TableRow ref={lastElementRef} key={club._id}>
      <TableCell className="px-4">
        <Avatar className="size-10">
          {club?.logo && <AvatarImage src={club.logo} alt={club?.name} />}
          <AvatarFallback>{club?.name?.substring(0, 1) || ""}</AvatarFallback>
        </Avatar>
      </TableCell>
      <TableCell className="px-4 text-sm">{club.name}</TableCell>
      <TableCell className="px-4 text-sm">{club.country}</TableCell>
      <TableCell className="px-4 text-sm">{club.founded || ""}</TableCell>
      <TableCell className="px-4 text-sm">{getSportTranslation(club.sport)}</TableCell>
      <TableCell className="px-4 text-sm">
        <span className="block max-w-[220px] truncate" title={club.contactInfo?.websiteUrl}>
          {club.contactInfo?.websiteUrl}
        </span>
      </TableCell>
      <TableCell className="px-4 text-sm">{club.isPremium ? t("yes") : t("no")}</TableCell>
      <TableCell className="px-4 text-right">
        <TableActionsMenu
          handleClickAction={handleClickActionMenu}
          handleCloseActionMenu={handleCloseActionMenu}
          rowData={club}
          actions={menuActions}
          anchorEl={menuAnchorEl}
          open={menuActionsOpen}
        />
      </TableCell>
    </TableRow>
  );
};

ClubsTableRow.propTypes = {};

export default ClubsTableRow;
